export class MoiCommentEditorConfig {
    title: string;
    hideProgress: boolean;
    hideFeasibility: boolean;
    commentRequired: boolean = true;
    checkProgress: boolean = false;
    checkProgressSubMessage: string;
}
